export default function getEntryType(metric) {
    if (
        window.PerformanceNavigationTiming &&
        metric instanceof PerformanceNavigationTiming
    ) {
        const data = {
            navigation_page_load: metric.loadEventEnd - metric.fetchStart,
            navigation_transfer_size: metric.transferSize,
            navigation_encoded_body_size: metric.encodedBodySize,
            navigation_dom_interactive: metric.domInteractive,
            navigation_dns_lookup_time:
                metric.domainLookupEnd - metric.domainLookupStart,
            navigation_compression_ratio:
                metric.decodedBodySize / metric.encodedBodySize,
            navigation_page_render: metric.domComplete,
            navigation_connect_time: metric.responseEnd - metric.requestStart,
            navigation_ttfb: metric.responseStart - metric.requestStart,
            navigation_type: metric.type,
        };
        return data;
    }
    if (
        window.PerformanceResourceTiming &&
        metric instanceof PerformanceResourceTiming
    ) {
        if (metric.name.includes('api.metrical-app')) {
            // Don't track POST requests to our service
            return;
        }
        const data = {
            resource_protocol: metric.nextHopProtocol,
            resource_type: metric.initiatorType,
            resource_url: metric.name,
            resource_duration: metric.responseEnd - metric.startTime,
            resource_encoded_size: metric.encodedBodySize,
            resource_transfer_size: metric.transferSize,
            resource_redirect_time: metric.redirectEnd - metric.redirectStart,
            resource_dns_lookup:
                metric.domainLookupEnd - metric.domainLookupStart,
            resource_tcp_handshake: metric.connectEnd - metric.connectStart,
            resource_response_time: metric.responseEnd - metric.responseStart,
        };
        return data;
    }
    if (
        window.PerformancePaintTiming &&
        metric instanceof PerformancePaintTiming
    ) {
        const name = `metric_${metric.name
            .split('-')
            .map((i) => i[0])
            .join('')}`;
        return {
            [name]: metric.startTime,
        };
    }

    if (
        window.PerformanceEventTiming &&
        metric instanceof PerformanceEventTiming
    ) {
        const duration = metric.duration;
        const delay = metric.processingStart - metric.startTime;
        const eventHandlerTime = metric.processingEnd - metric.processingStart;
        return {
            event_target: metric.target,
            event_name: metric.name,
            event_interactionId: metric.interactionId,
            event_duration: duration,
            event_delay: delay,
            event_handler_time: eventHandlerTime,
        };
    }

    if (
        window.PerformanceLongTaskTiming &&
        metric instanceof PerformanceLongTaskTiming
    ) {
        return {
            long_task_name: metric.name,
            long_task_duration: metric.duration,
            long_task_start: metric.startTime,
        };
    }

    if (metric.name === 'CLS') {
        return {
            metric_cls: metric.value,
        };
    }
    if (metric.name === 'LCP') {
        return {
            metric_lcp: metric.value,
        };
    }
    if (metric.name === 'FID') {
        return {
            metric_fid: metric.value,
        };
    }
}
